<template>
  <div class="my-table applicationPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t("applicationManagement.txt1")}}</span>
        <span>{{$t("applicationManagement.txt2")}} / {{$t("applicationManagement.txt3")}}</span>
      </div>
      <div class="flexEnd">
        <div class="handleBoxSelect">
          <el-select v-model="queryInfo.type" :placeholder="$t('applicationManagement.txt26')" @change="loadData">
            <el-option
              v-for="(item,index) in typeList"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="handleBoxSeach flexCenter">
          <el-input
            :placeholder="$t('applicationManagement.txt4')"
             v-model="queryInfo.name" @keypress.native.enter="loadData">
            <img slot="prefix" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
          </el-input>
          <div class="searchBtn" @click="loadData">{{$t("applicationManagement.txt5")}}</div>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <el-card class="noBg">
      <el-table :data="dataList" :default-sort = "{prop: 'projName', order: 'descending'}" :row-class-name="tableRowClassName">
          <el-table-column
            :label="$t('applicationManagement.txt6')"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column :label="$t('applicationManagement.txt7')">
            <template slot-scope="scope">
              <span>{{scope.row.name?scope.row.name:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('applicationManagement.txt8')">
            <template slot-scope="scope">
              <span>{{scope.row.version?scope.row.version:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('applicationManagement.txt9')" >
            <template slot-scope="scope">
              <span>{{scope.row.description?scope.row.description:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('applicationManagement.txt10')" >
            <template slot-scope="scope">
              <span>{{scope.row.type?scope.row.type:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('applicationManagement.txt11')" >
            <template slot-scope="scope">
              <span :class="scope.row.installStatus == 1?'greenTxt':scope.row.installStatus == 2?'orangeTxt':''">
                <span v-if="scope.row.installStatus == 0">{{$t("applicationManagement.txt12")}}</span>
                <span v-else-if="scope.row.installStatus == 1">{{$t("applicationManagement.txt13")}}</span>
                <span v-else-if="scope.row.installStatus==2">{{$t("applicationManagement.txt14")}}</span>
                <span v-else>--</span>
            <!--   {{scope.row.installStatus == 0?'未安装':scope.row.installStatus == 1?'已安装':scope.row.installStatus==2?'安装中':'--'}} -->
            </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('applicationManagement.txt15')"  width="240">
            <template slot-scope="scope">
                <!-- <el-button class="deepHandleTxt" @click="handleUpdate(scope.row)" type="text">更新</el-button> -->
                <el-button class="deepHandleTxt" v-if="scope.row.installStatus == 1" @click="handleUninstall(scope.row)" type="text">{{$t("applicationManagement.txt16")}}</el-button>
                <el-button class="deepHandleTxt" v-if="scope.row.installStatus == 0" @click="handleInstall(scope.row)" type="text">{{$t("applicationManagement.txt17")}}</el-button>
            </template>
          </el-table-column>
      </el-table>
    </el-card>
    <div class="table-footer tablePagination" v-show="total>0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNo"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        total:0,
        //用于获取数据列表
        queryInfo: {
          type:'',
          name:'',
          pageNo:0,
          pageSize:10
        },
        dataList: [],
        activeIndex:0,
        typeList:[],
      };
    },
    created() {
      this.loadData();
      this.getAllType();
    },
    methods: {
       // 数据加载(查询app)
      async loadData(){
        const { data: res } = await this.$http.post("/application/list?"+qs.stringify(this.queryInfo));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.dataList = res.result.data;
        this.total = res.result.total;
      },
      tableRowClassName({row, rowIndex}) {
        if (row.installStatus == 2) {
          return 'warning-row';
        } else if (row.installStatus == 1) {
          return 'success-row';
        }
        return '';
      },
      // 获取所有应用类型
      async getAllType(){
       const { data: res } = await this.$http.post("/application/types");
       if(!res.success){
         return this.$message.error(res.message);
       }
       this.typeList = [
        {
          value:'',
          label:'全部'
        },
       ]
       let list = res.result;
       list.map(e=>{
        let item = {
          value:e,
          label:e
        }
        this.typeList.push(item);
       })
      },
      getType(item,index){
        this.activeIndex = index;
        this.queryInfo.type = item.value;
        this.loadData();
      },
      // 删除
      handleDelete(){
        this.$confirm('<p class="color666 fz14">'+this.$t('applicationManagement.txt18')+'</p><p class="color999 fz14">'+this.$t('applicationManagement.txt19')+'</p>', this.$t('applicationManagement.txt20'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('applicationManagement.txt21'),
          cancelButtonText: this.$t('applicationManagement.txt22'),
          type: 'warning',
          center: true
        }).then(() => {
          this.$message({
            type: 'info',
            message: this.$t('applicationManagement.txt23')
          }); 
        }).catch(() => {
          this.$message({
            type: 'success',
            message:this.$t('applicationManagement.txt24')
          });         
        });
      },
      // 卸载
      async handleUninstall(row){
        let data = {
          name:row.name,
          version:row.version
        }
        const { data: res } = await this.$http.post("/application/un/install?"+qs.stringify(data));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.$message({
          message: this.$t('applicationManagement.txt25'),
          type: 'success'
        });
        this.loadData();
      },
      // 安装
      async handleInstall(row){
        let data = {
          name:row.name,
          version:row.version
        }
        const { data: res } = await this.$http.post("/application/install?"+qs.stringify(data));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.$message({
          message: this.$t('applicationManagement.txt25'),
          type: 'success'
        });
        this.loadData();
      },
       // 更新
      async handleUpdate(row){
        let data = {
          name:row.name,
          version:row.version
        }
        const { data: res } = await this.$http.post("/application/update?"+qs.stringify(data));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.$message({
          message: this.$t('applicationManagement.txt25'),
          type: 'success'
        });
        this.loadData();
      },
      // 页面切换
      handleCurrentChange(page) {
        this.queryInfo.pageNo = page;
        this.loadData();
      },
      handleSizeChange(size){
        this.queryInfo.pageSize = size;
        this.loadData();
      },
    },
  };
</script>

<style lang="less">
  .applicationPage{
    .el-table .warning-row {
      background: #FFFAF5;
    }
  
    .el-table .success-row {
      background: #F3F8F5;
    }
    .labelTxt{
      width: 8rem;
    }
    .w32{
       /deep/ .el-input,/deep/ .el-input__inner{
         width: 100% !important;
       }
     }
    .searchBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      .btnC{
        padding:0.6rem 2.6rem;
      }
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    .orangeTxt{
      color: #F39E31;
    }
    .greenTxt{
      color: #1B7C3A;
    }
    .warning-row td:first-of-type{
      border-left: 3px solid #F39E31;
      border-radius: 3px 0px 0px 3px;
    }
    .success-row td:first-of-type{
      border-left: 3px solid #1B7C3A;
      border-radius: 3px 0px 0px 3px;
    }
  }
</style>
